export default "__VITE_ASSET__g__WrhW5__"